import _Vue from "vue";
import app from "@/main";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";

export class Helper {
    // Mutlak anları Türkiye saatinde göstermek için. Saat dilimi açıkça verildiği
    // için sonuç, kullanıcının makinesinin saat diliminden bağımsızdır.
    private static readonly TR_TARIH_SAAT = new Intl.DateTimeFormat('tr-TR', {
        timeZone: 'Europe/Istanbul',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    });

    download(name: string, URL: string) {
        return new Promise((resolve, reject) => {
            app.$http({
                url: URL,
                method: 'GET',
                responseType: 'blob'
            }).then((response: any) => {
                let fileURL = window.URL.createObjectURL(new Blob([!!response.data ? response.data : response]));
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', name);
                document.body.appendChild(fileLink);
                fileLink.click();
                resolve(response);
            }).catch((error) => {
                app.$toast.error(error.message)
                reject(error.message);
            });
        });
    }

    tarihStr(val: Date | string): string {
        try {
            if (typeof val === "string") { //
                return val.substr(0, 10).split('-').reverse().join('/');
            } else if (typeof val === "object") {
                return val.toISOString().substr(0, 10).split('-').reverse().join('/');
            }
        } catch (e) {
            console.error(e)
        }
        return "";
    }

    saatStr(val: Date | string): string {
        try {
            if (typeof val === "string") {
                return val.substr(11, 8);
            } else if (typeof val === "object") {
                return val.toISOString().substr(11, 5);
            }
        } catch (e) {
            console.error(e)
        }
        return "";
    }

    /**
     * @param val           Gösterilecek değer.
     * @param convertToUtc3 true ise val MUTLAK BİR AN kabul edilir ve Türkiye
     *                      saatinde biçimlendirilir. false ise değer olduğu gibi
     *                      (metinsel olarak) parçalanır — saat dilimi çevrimi yapılmaz.
     */
    tarihSaatStr(val: Date | string | null, convertToUtc3: boolean = false): string {
        if (val === null || typeof val === "undefined" || val === "") {
            return "";
        }
        try {
            if (convertToUtc3) {
                // Eskiden burada new Date(val).getHours() + 3 yapılıyordu. getHours()
                // makinenin YEREL saatini döndürdüğü için bu, yalnızca makine
                // Europe/Istanbul'dayken doğru sonuç veriyordu; başka bir saat
                // diliminde kullanıcıya yanlış saat gösteriyordu.
                const date: Date = val instanceof Date ? val : new Date(val);
                if (isNaN(date.getTime())) {
                    return "";
                }
                const p: any = {};
                for (const parca of Helper.TR_TARIH_SAAT.formatToParts(date)) {
                    p[parca.type] = parca.value;
                }
                // Mevcut görünüm korunuyor: GG/AA/YYYY SS:dd:ss
                return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
            }
            return this.tarihStr(val) + " " + this.saatStr(val);
        } catch (e) {
            return "";
        }
    }

    tutarStr(val: number, paraBirimi: ParaBirimiEntity | null = null): string {
        // let temp = new Intl.NumberFormat('tr-TR', {style: 'currency', currency: 'TRY'}).format(val);
        if (!val) {
            val = 0.00;
        }
        return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2}).format(val) + " " + (paraBirimi ? paraBirimi?.kisa_isim : " TL");

    }
}

export default function HelperPlugin(Vue: typeof _Vue): void {
    Vue.prototype.$helper = new Helper();
}